import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { heroImages } from '../data/mock';

export const HeroSection = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []); // heroImages is static, no need in deps

  return (
    <section style={{
      position: 'relative',
      height: '90vh',
      minHeight: '600px',
      overflow: 'hidden'
    }}>
      {/* Background Images with Crossfade */}
      {heroImages.map((image, index) => {
        return (
          <div
            key={`hero-${image.substring(image.lastIndexOf('/') + 1, image.lastIndexOf('/') + 20)}`}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundImage: `url(${image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
              opacity: currentImage === index ? 1 : 0,
              transition: 'opacity 1.5s ease-in-out'
            }}
          />
        );
      })}

      {/* Dark Overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.10), rgba(0,0,0,0.25))'
      }} />

      {/* Content */}
      <div style={{
        position: 'relative',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '0 20px'
      }}>
        <div style={{ maxWidth: '900px' }}>
          <h1 style={{
  fontSize: 'clamp(32px, 5vw, 56px)',
  fontWeight: 400,
  lineHeight: 1.2,
  fontFamily: "'Crimson Text', serif",
  color: '#F7F3E8',
  marginBottom: '24px',
  textShadow: '0 2px 8px rgba(0, 0, 0, 0.75)'
}}>
            Discover Journeys Beyond the Ordinary
          </h1>
          <p style={{
            fontSize: 'clamp(16px, 2vw, 20px)',
            fontWeight: 400,
            lineHeight: 1.6,
            color: '#ffffff',
            marginBottom: '12px',
            textShadow: '0 1px 10px rgba(0,0,0,0.3)'
          }}>
            Bespoke journeys across Indonesia and beyond, thoughtfully crafted around culture, nature, heritage, gastronomy and meaningful experiences.
          </p>
          <p style={{
            fontSize: 'clamp(13px, 1.5vw, 15px)',
            fontWeight: 400,
            color: 'rgba(255,255,255,0.9)',
            marginBottom: '48px',
            textShadow: '0 1px 8px rgba(0,0,0,0.3)',
            letterSpacing: '0.5px'
          }}>
            Private Journeys • Small Groups • Tailor-Made Experiences
          </p>
          <div style={{
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link to="/indonesia-journeys" style={{
              background: '#ffffff',
              color: '#333333',
              border: '1px solid #ffffff',
              borderRadius: 0,
              padding: '19px 23px',
              minWidth: '210px',
              height: '60px',
              fontSize: '14px',
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'background 0.2s, color 0.2s',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#ffffff';
              e.target.style.color = '#333333';
            }}>
              Explore Our Journeys
              <ArrowRight size={16} />
            </Link>
            <Link to="/b2b/register" style={{
              background: 'transparent',
              color: '#ffffff',
              border: '1px solid #ffffff',
              borderRadius: 0,
              padding: '19px 23px',
              minWidth: '210px',
              height: '60px',
              fontSize: '14px',
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'background 0.2s, color 0.2s',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#ffffff';
              e.target.style.color = '#333333';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#ffffff';
            }}>
              Become a B2B Partner
            </Link>
          </div>
        </div>
      </div>

      {/* Image Indicators */}
      <div style={{
        position: 'absolute',
        bottom: '40px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '12px',
        zIndex: 10
      }}>
        {heroImages.map((image, index) => (
          <button
            key={`indicator-${index}-${image.substring(image.lastIndexOf('/') + 1, image.lastIndexOf('/') + 15)}`}
            onClick={() => setCurrentImage(index)}
            style={{
              width: currentImage === index ? '40px' : '12px',
              height: '3px',
              background: currentImage === index ? '#ffffff' : 'rgba(255,255,255,0.4)',
              border: 'none',
              cursor: 'pointer',
              transition: 'width 0.3s ease, background 0.3s ease'
            }}
            aria-label={`View image ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};
